<template>
  <div class="row">
    <div class="col">
      <div v-if="hasErr" class="row my-1">
        <div class="col">
          <small class="form-text alert alert-danger" v-text="err"></small>
        </div>
      </div>
      <div class="row my-1">
        <div class="col">
          <form class="form-inline" @submit.prevent="doRemember" autocomplete="off">
            <label class="mx-2">Put</label>
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="put.subject"
              list="subjects"
              placeholder="Subject"
            >
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="put.predicate"
              list="predicates"
              placeholder="Predicate"
            >
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="put.object"
              list="objects"
              placeholder="Object"
            >
            <button type="submit" class="btn btn-primary mx-2">Remember</button>
            <button type="reset" class="btn btn-light mx-2" @click="resetPut">Reset</button>
          </form>
        </div>
      </div>
      <div class="row my-1">
        <div class="col">
          <form class="form-inline" @submit.prevent="doRecollect" autocomplete="off">
            <label class="mx-2">Get</label>
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="get.subject"
              list="subjects"
              placeholder="Subject"
            >
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="get.predicate"
              list="predicates"
              placeholder="Predicate"
            >
            <input
              type="text"
              class="form-control mx-1"
              v-model.trim.lazy="get.object"
              list="objects"
              placeholder="Object"
            >
            <button type="submit" class="btn btn-success mx-2">Recollect</button>
            <button type="reset" class="btn btn-light mx-2" @click="resetGet">Clear</button>
          </form>
        </div>
      </div>
      <div class="row my-1" v-if="recollection.memories.length">
        <div class="col">
          <table class="table table-sm table-borderless table-hover">
            <caption>Cathea remembers these memories for you</caption>
            <thead>
              <tr>
                <th scope="col">Subject</th>
                <th scope="col">Predicate</th>
                <th scope="col">Object</th>
                <th scope="col">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <triple
                v-for="({subject= recollection.subject, predicate= recollection.predicate, object= recollection.object}, index) in recollection.memories"
                :key="index"
                :index="index"
                :subject="subject"
                :predicate="predicate"
                :object="object"
                v-on:delete="doForget"
              ></triple>
            </tbody>
          </table>
        </div>
      </div>
      <datalist id="subjects">
        <option v-for="(subject, index) in my.subjects" :key="index" :value="subject"></option>
      </datalist>
      <datalist id="predicates">
        <option v-for="(predicate, index) in my.predicates" :key="index" :value="predicate"></option>
      </datalist>
      <datalist id="objects">
        <option v-for="(object, index) in my.objects" :key="index" :value="object"></option>
      </datalist>
    </div>
  </div>
</template>

<script type='text/babel'>
import TripleComponent from '@/components/Triple'

import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateUser, mapGetters: mapGettersUser, mapActions: mapActionsUser } = createNamespacedHelpers('user/session')

export default {
  name: 'User',
  components: {
    triple: TripleComponent
  },
  data: () => ({
    put: {
      subject: '',
      predicate: '',
      object: ''
    },
    get: {
      subject: '',
      predicate: '',
      object: ''
    }
  }),
  computed: { ...mapStateUser(['my', 'recollection', 'err']), ...mapGettersUser(['hasErr']) },
  methods: {
    ...mapActionsUser(['hook', 'unhook', 'remember', 'forget', 'refresh', 'recollect']),
    async doRemember () {
      const _self = this

      await _self.remember({
        subject: _self.put.subject,
        predicate: _self.put.predicate,
        object: _self.put.object
      })

      await _self.refresh()
      await _self.resetPut()
    },
    async doRecollect () {
      const _self = this
      await _self.recollect({
        subject: _self.get.subject,
        predicate: _self.get.predicate,
        object: _self.get.object
      })
    },
    async doForget (index, memory) {
      const _self = this
      await _self.forget({ index, memory })
      await _self.refresh()
    },
    async resetPut () {
      const _self = this

      _self.put.subject = ''
      _self.put.predicate = ''
      _self.put.object = ''
    },
    async resetGet () {
      const _self = this

      _self.get.subject = ''
      _self.get.predicate = ''
      _self.get.object = ''

      // _self.internal.results.length = 0 // Clear all results
    }
  },
  async mounted () {
    const _self = this
    await _self.hook()
    await _self.refresh()
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style type='text/css' lang='css' scoped>
</style>
